/**
 * Dernière méthode de connexion utilisée sur ce navigateur : « password »
 * (Hosted UI) ou « passkey » (Touch ID).
 *
 * Ce n'est qu'un indice d'affichage, et il évite une régression. Avant l'écran
 * de connexion, recharger la page renvoyait au Hosted UI, dont le cookie de
 * session rouvrait la GUI sans rien saisir. Avec l'écran de connexion, il faut
 * continuer à le faire pour qui s'est connecté par mot de passe — et ne pas le
 * faire pour qui utilise Touch ID, qui n'a pas de session Hosted UI.
 *
 * Aucun jeton ici, jamais.
 */
export type LoginHint = "password" | "passkey";

const KEY = "ps.cp.loginHint";

export function getLoginHint(): LoginHint | null {
  try {
    const value = window.localStorage.getItem(KEY);
    return value === "password" || value === "passkey" ? value : null;
  } catch {
    return null;
  }
}

export function setLoginHint(hint: LoginHint | null): void {
  try {
    if (hint === null) window.localStorage.removeItem(KEY);
    else window.localStorage.setItem(KEY, hint);
  } catch {
    // Stockage indisponible : l'indice est facultatif.
  }
}
